/**
 * Google Maps integration
 * Ce fichier est chargé uniquement sur les pages avec cartes (archive-magasin, single-magasin)
 * Il attend que l'API Google Maps soit complètement chargée via le callback initGoogleMaps
 */

// Fonction callback appelée automatiquement par Google Maps quand l'API est prête
window.initGoogleMaps = function () {
	// Initialiser l'autocomplete sur les champs de recherche
	initAutocompleteStores();

	// Initialiser la carte si présente
	initMap();
};

/**
 * Autocomplete pour la recherche de magasins
 */
function initAutocompleteStores() {
	const inputs = document.querySelectorAll('[data-google-autocomplete]');
	if (!inputs || inputs.length === 0) return;

	// Vérifier que Google Maps et la bibliothèque Places sont bien chargés
	if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
		console.error('Google Maps Places API non chargée');
		return;
	}

	inputs.forEach((input) => {
		const form = input.closest('form');
		const options = {
			componentRestrictions: { country: 'fr' },
			fields: ['address_components', 'geometry', 'icon', 'name'],
			strictBounds: false,
			types: ['(cities)'],
		};

		const gAutocomplete = new google.maps.places.Autocomplete(input, options);

		gAutocomplete.addListener('place_changed', () => {
			if (form) form.submit();
		});
	});
}

/**
 * Initialise la carte Google Maps avec les marqueurs
 */
function initMap() {
	const mapElement = document.getElementById('map');
	if (!mapElement) return;

	// Vérifier que Google Maps est bien chargé
	if (typeof google === 'undefined' || !google.maps) {
		console.error('Google Maps API non chargée');
		return;
	}

	const stores = JSON.parse(mapElement.dataset.stores || '[]');
	const other = JSON.parse(mapElement.dataset.other || '[]');
	const center = JSON.parse(mapElement.dataset.center || '{}');

	const gmap = new google.maps.Map(mapElement, {
		disableDefaultUI: true,
		zoom: 8,
		maxZoom: 19,
	});

	if (center.lat && center.lng) {
		gmap.setCenter({ lat: parseFloat(center.lat), lng: parseFloat(center.lng) });
	}

	const bounds = new google.maps.LatLngBounds();

	// Ajouter les marqueurs des magasins principaux
	if (stores && stores.length > 0) {
		stores.forEach((store) => {
			addMarker(store, gmap, bounds, true);
		});
	}

	// Ajouter les marqueurs des autres magasins
	if (other && other.length > 0) {
		other.forEach((store) => {
			addMarker(store, gmap, bounds, stores.length > 0 ? false : true);
		});
	}

	gmap.fitBounds(bounds);
}

/**
 * Ajoute un marqueur sur la carte
 * @param {Object} store - Données du magasin
 * @param {google.maps.Map} gmap - Instance de la carte
 * @param {google.maps.LatLngBounds} bounds - Limites de la carte
 * @param {boolean} inBounds - Si le marqueur doit être inclus dans les limites
 */
function addMarker(store, gmap, bounds, inBounds = true) {
	const point = {
		lat: parseFloat(store.coordinate.lat),
		lng: parseFloat(store.coordinate.lng),
	};

	const marker = new google.maps.Marker({
		position: point,
		map: gmap,
		icon: window.templateUri + '/static/img/marker.png',
		title: store.post_title,
	});

	if (inBounds) {
		bounds.extend(point);
	}

	// Gestion du clic sur le marqueur pour afficher une popup
	marker.addListener('click', () => {
		const overlay = document.createElement('div');
		overlay.classList.add('overlay');
		document.body.append(overlay);

		const clone = document.querySelector(`[data-id="${store.id}"]`).cloneNode(true);
		clone.classList.add(
			'fixed',
			'mt-6',
			'transition-all',
			'duration-500',
			'opacity-0',
			'invisible',
			'z-goku',
			'w-84',
			'top-1/2',
			'left-1/2',
			'transform-gpu',
			'-translate-x-1/2',
			'-translate-y-1/2'
		);
		document.body.append(clone);

		// Fermer la popup au clic sur l'overlay
		overlay.addEventListener('click', (e) => {
			e.preventDefault();
			overlay.classList.add('opacity-0', 'invisible');
			clone.classList.add('opacity-0', 'invisible');
			setTimeout(() => {
				overlay.remove();
				clone.remove();
			}, 500);
		});

		// Afficher la popup avec animation
		setTimeout(() => {
			clone.classList.remove('mt-6', 'opacity-0', 'invisible');
		}, 100);
	});
}
